import { render, staticRenderFns } from "./QuestionsCharts.component.vue?vue&type=template&id=a9c346d2&scoped=true&"
import script from "./QuestionsCharts.component.vue?vue&type=script&lang=js&"
export * from "./QuestionsCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsCharts.component.vue?vue&type=style&index=0&id=a9c346d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c346d2",
  null
  
)

export default component.exports